import { render, staticRenderFns } from "./project-copy.vue?vue&type=template&id=0cc249a1&"
import script from "./project-copy.vue?vue&type=script&lang=ts&"
export * from "./project-copy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports